import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const GroupBox = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      d="M17 4H7v3H4v10h3v3h10v-3h3V7h-3V4Zm4 13V3H3v18h18v-4Zm-1 1h-2v2h2v-2ZM4 20v-2h2v2H4ZM18 4v2h2V4h-2ZM4 4h2v2H4V4Z"
      clip-rule="evenodd"
    />
  </SvgIcon>
);

export default GroupBox;
